import { render, staticRenderFns } from "./FrameworkList.vue?vue&type=template&id=1b6a4edf"
import script from "./FrameworkList.vue?vue&type=script&lang=js"
export * from "./FrameworkList.vue?vue&type=script&lang=js"
import style0 from "./FrameworkList.vue?vue&type=style&index=0&id=1b6a4edf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports